import { ComponentType } from "react";
import type { OAuthFormState } from "../OAuthFormContext";
import { appleExtension } from "./apple";
import { githubExtension } from "./github";
import { googleExtension } from "./google";
import { linkedinExtension } from "./linkedin";
import { slackExtension } from "./slack";
import { twitterExtension } from "./twitter";

// Mirror of the C# SetIntegrationOAuthRequest payload.
export interface OAuthSavePayload {
  native_audiences?: string[];
  web_client_id?: string;
  web_client_secret?: string;
  apple_private_key?: string;
  apple_key_id?: string;
  apple_team_id?: string;
  allow_missing_email?: boolean;
  is_enabled?: boolean;
  use_social_sign_in: boolean;
}

export interface ProviderLabels {
  nativeAudienceLabel?: string;
  nativeAudiencePlaceholder?: string;
  nativeAudienceHint?: string;
  webClientIdLabel?: string;
  webClientIdPlaceholder?: string;
}

export interface ProviderExtension {
  labels?: ProviderLabels;
  WebSecretMethod?: ComponentType;
  WebSecretBody?: ComponentType;
  webSecretBodyShownWhen?: (state: OAuthFormState) => boolean;
  hideGenericClientSecretWhen?: (state: OAuthFormState) => boolean;
  Advanced?: ComponentType;
  buildPayloadExtras?: (state: OAuthFormState, payload: OAuthSavePayload) => void;
  shouldSkipDefaultClientSecret?: (state: OAuthFormState) => boolean;
}

const registry: Record<string, ProviderExtension> = {
  apple: appleExtension,
  google: googleExtension,
  linkedin: linkedinExtension,
  github: githubExtension,
  slack: slackExtension,
  twitter: twitterExtension,
};

export function getProviderExtension(providerId: string): ProviderExtension {
  return registry[providerId] ?? {};
}
